export default __webpack_public_path__ + "static/media/assets_BKLOGO.284eb4bb.png";